var React = require('react');

function Opened (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.575 1h5.85C9.294 1 10 1.706 10 2.575v14.85C10 18.294 9.294 19 8.425 19h-5.85A1.576 1.576 0 0 1 1 17.425V2.575C1 1.706 1.706 1 2.575 1zM8 15H3v2h5v-2zM8 5V3H3v2h5zm-5 5v4h5V6H3v1.5h2V10H3zm15.5-6c.828 0 1.5.736 1.5 1.643v8.714c0 .907-.672 1.643-1.5 1.643s-1.5-.736-1.5-1.643V5.643C17 4.736 17.672 4 18.5 4zM14 7h2v2h-2V7zm-3 0h2v2h-2V7z","fill":"currentColor"}));
}

Opened.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Opened;

Opened.default = Opened;
